module.exports = "/contribution/resources/b4f68241fbe65ef6803158f2ac7e6de6.pdf";